class FadeSlideshow {
    constructor(container) {
        this.container = container;
        this.slides = Array.from(container.querySelectorAll('.fade-slideshow__slide'));
        this.dots = Array.from(container.querySelectorAll('.fade-slideshow__dot'));
        this.prevBtn = container.querySelector('.fade-slideshow__arrow--prev');
        this.nextBtn = container.querySelector('.fade-slideshow__arrow--next');

        this.current = 0;
        this.autoplay = container.dataset.autoplay === 'true';
        this.touchStartX = 0;

        if (this.slides.length <= 1) return;

        this.bindEvents();
    }

    bindEvents() {
        this.dots.forEach((dot) => {
            dot.addEventListener('click', () => {
                this.goTo(parseInt(dot.dataset.index, 10));
            });
            dot.addEventListener('animationend', (e) => {
                if (e.animationName === 'fadeSlideshowLoadingBar' && this.autoplay) {
                    this.goTo(this.current + 1);
                }
            });
        });

        if (this.prevBtn) {
            this.prevBtn.addEventListener('click', () => {
                this.goTo(this.current - 1);
            });
        }

        if (this.nextBtn) {
            this.nextBtn.addEventListener('click', () => {
                this.goTo(this.current + 1);
            });
        }

        this.container.addEventListener('touchstart', (e) => {
            this.touchStartX = e.touches[0].clientX;
        }, { passive: true });

        this.container.addEventListener('touchend', (e) => {
            const deltaX = e.changedTouches[0].clientX - this.touchStartX;
            if (Math.abs(deltaX) > 40) {
                this.goTo(deltaX < 0 ? this.current + 1 : this.current - 1);
            }
        }, { passive: true });
    }

    goTo(index) {
        const total = this.slides.length;
        const nextIndex = ((index % total) + total) % total;
        if (nextIndex === this.current) return;

        this.slides[this.current].classList.remove('is-active');
        if (this.dots[this.current]) {
            this.dots[this.current].classList.remove('is-active');
            this.dots[this.current].setAttribute('aria-selected', 'false');
        }

        this.slides[nextIndex].classList.add('is-active');
        
        if (this.dots[nextIndex]) {
            // Force a reflow on the dot to ensure the CSS animation reliably restarts from 0%
            this.dots[nextIndex].classList.remove('is-active');
            void this.dots[nextIndex].offsetWidth;
            this.dots[nextIndex].classList.add('is-active');
            this.dots[nextIndex].setAttribute('aria-selected', 'true');
        }

        this.current = nextIndex;
    }
}

document.querySelectorAll('.fade-slideshow').forEach((el) => new FadeSlideshow(el));